import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';

export const HelpButton = styled(Button)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
`;
